export const CHANGE_PROGRAMS_SUCCESS = 'CHANGE_PROGRAMS_SUCCESS'